const customSwiper = {
  thumbs: null,
  classes:{
    swiper_thumbs: 'custom-swiper-thumbs',
    swiper: 'custom-swiper'
  },
  is: (swiper, classname) =>{
    return $(swiper.el).hasClass(classname);
  }
}
const sections = {
  video: 'video-section'
}
function initNewSwiper(swiper_selector, thumbs_of_swiper = null){
  /*
    swiper_selector -> to prevent conflicts it is better to use id
    the swipe settings could be assigned in html with data attributes to the swiper_selector
    if something is not set - it gets a default val
    feel free to bring more stuff :)
    
    thumbs_of_swiper -> when slider has thumbs: the function is called like initBangSwiper('thumbs-slider', 'main-slider')
      after the thumbs-slider is initialized, it will call automaticaly init of the main-slider
  */
  var swiper_element = $(swiper_selector);
  var effect = swiper_element.data('effect') ? $(swiper_element).data('effect') : 'slide';
  
  //speed and autoplayDelay can accept value 0
  var speed = typeof swiper_element.data('speed') != "undefined" ? $(swiper_element).data('speed') : 2500;
  
  /*set data-autoplay="false" to disable autoplay; any other value in ms like 1000 2000 will activate the autoplay*/
  var autoplayDelay = typeof swiper_element.data('autoplay') != "undefined" ? $(swiper_element).data('autoplay') : 1000;
  var autoplayMobile = typeof swiper_element.data('autoplay-mobile') != "undefined" ? $(swiper_element).data('autoplay-mobile'): 5000;
  
  var autoplayMobileSettings = false;

  if(autoplayMobile) {
    var autoplayMobileSettings = {
      delay: autoplayMobile,
      disableOnInteraction: false,
    };
  }
  
  var autoplaySubSettings = false;
  if(autoplayDelay){
    var autoplaySubSettings = {
      delay: autoplayDelay,
      disableOnInteraction: false,
    };
  }
   
  var loop = (swiper_element.data('loop') === true);
  var perViewMobile = swiper_element.data('per-view-mobile') ? $(swiper_element).data('per-view-mobile') : 1;
  var perViewTablet = swiper_element.data('per-view-tablet') ? $(swiper_element).data('per-view-tablet') : 1;
  var perViewTablet__big = swiper_element.data('per-view-tablet-big') ? $(swiper_element).data('per-view-tablet-big') : false;
  var perViewDesktop = swiper_element.data('per-view-desktop') ? $(swiper_element).data('per-view-desktop') : 1;
  var betweenMobile = swiper_element.data('between-mobile') ? $(swiper_element).data('between-mobile') : 15;
  var betweenTablet = swiper_element.data('between-tablet') ? $(swiper_element).data('between-tablet') : 15;
  var betweenDesktop = swiper_element.data('between-desktop') ? $(swiper_element).data('between-desktop') : 15;
  var initialSlideMobile = swiper_element.data('initial-slide-mobile') ? $(swiper_element).data('initial-slide-mobile') : 0;  
  var initialSlideTablet = swiper_element.data('initial-slide-tablet') ? $(swiper_element).data('initial-slide-tablet') : 0;
  var mobile_centered = swiper_element.data('mobile-centered') ? $(swiper_element).data('mobile-centered') : false;  
  var tablet_centered = swiper_element.data('tablet-centered') ? $(swiper_element).data('tablet-centered') : false;
  var slider_direction = swiper_element.data('slider-direction') ? $(swiper_element).data('slider-direction') : "horizontal";

//   var widthMobile = swiper_element.data('width-mobile') ? $(swiper_element).data('width-mobile'): console.log('skip') ;
  var navigationSubSettings = false;
    
  var thumbSettings = thumbs_of_swiper !== null  && {
    slideToClickedSlide: true,
    centeredSlides: true,
    threshold: 2,
    noSwipingClass: 'swiper-slide',
    noSwiping: true,
  }

  var swiper_f = new Swiper(swiper_selector, {
        effect: effect,
        slidesPerView: perViewMobile,
        spaceBetween: betweenMobile,
        loop: loop,
        speed: speed,
        freeMode: {
          enabled: false,
          momentumRatio: 0.2,
          momentumBounce: false,
          momentumVelocityRatio: 1,
          sticky: true
        },
        noSwipingClass: 'disabled',
        noSwiping: true,
        ...thumbSettings,
        mousewheel: false,
        direction: slider_direction,
        observer: true,
    	observerUpdate: true,
        observeSlideChildren: true,
        scrollbar: {
           //el: '.swiper-scrollbar',
           draggable: true,
        },
        pagination: {
           el: swiper_selector +" .swiper-pagination",
           clickable: true,
        },
        keyboard: {
           enabled: true,
           onlyInViewport: false,
        },
        breakpoints: {
          320: {
            spaceBetween: betweenMobile,
            autoplay: autoplayMobileSettings,
            centeredSlides: mobile_centered,
            initialSlide: initialSlideMobile
          },
          750: { /*750 and up to next*/
            slidesPerView: perViewTablet,
            spaceBetween: betweenTablet,
            autoplay: autoplayMobileSettings,
            centeredSlides: tablet_centered,
            initialSlide: initialSlideTablet
          },
          989: { /*990 and up to next*/
            slidesPerView: (perViewTablet__big ? perViewTablet__big : perViewDesktop),
            spaceBetween: betweenDesktop,
          },
          1080: {
            slidesPerView: perViewDesktop,
            spaceBetween: betweenDesktop,
            autoplay: autoplaySubSettings,
          }
        },
        thumbs: {
          swiper: thumbs_of_swiper,
        },
        navigation: navigationSubSettings,
        on: {
          slideChangeTransitionStart: function(swiper){
            if(navigationSubSettings){
              if( !$(`${swiper_selector} .swiper-slide:first`).hasClass('swiper-slide-active') ){
                $(navigationSubSettings.prevEl).fadeIn();
              }
              if( !swiper.isEnd ){
                $(navigationSubSettings.nextEl).fadeIn();
              }
            }
          },
          reachBeginning: function(){
            $(navigationSubSettings.prevEl).fadeOut();
          },
          reachEnd: function(){
            $(navigationSubSettings.nextEl).fadeOut();
          },
        }
  });

  swiper_f.init();
    
  $('.swiper-button-next').on( "click", function() {
    var section = $(this).data('for-section');
    if(section && swiper_selector == '#'+section){
        swiper_f.slideNext();
    }
  });
  
  $('.swiper-button-prev').on( "click", function() {
    var section = $(this).data('for-section');
    if(section && swiper_selector == '#'+section){
        swiper_f.slidePrev();
    }
  });
  
  if(swiper_element.data("thumbs-to")){
    customSwiper.thumbs = initNewSwiper(swiper_element.data("thumbs-to"), swiper_f);
  }
  
  swiper_f.on('slideChangeTransitionEnd', function(swiper){
    const isPDPSlider = customSwiper.is(swiper, 'product_slider');
    if(isPDPSlider){
      customSwiper.thumbs != null &&  customSwiper.thumbs.slideTo(swiper.activeIndex, 0, false) && customSwiper.thumbs.update();
    }
  });
  
  return swiper_f;
}

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
    const waitStep = 500
	const $window = jQuery(window)
	const viewport_top = $window.scrollTop();
	const viewport_height = $window.height()
	const viewport_bottom = viewport_top + viewport_height
	const $elem = jQuery(elem)
	const top = $elem.offset().top + waitStep
	const height = $elem.height()
	const bottom = top + height - (waitStep * 1.5) ;

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
  }
  


$(document).ready(function(){
  $(`.${customSwiper.classes.swiper}`).each(function(){
    initNewSwiper('#'+$(this).attr('id'));
  });
  $(`.${customSwiper.classes.swiper_thumbs}`).each(function(){
    initNewSwiper('#'+$(this).attr('id'));
  });
  
  customSwiper?.thumbs?.thumbs?.swiper.on('touchStart', function(swiper, event){
    const slideIndex = $(event?.path?.[0]).closest('.swiper-slide').index();
    customSwiper.thumbs.slideTo(slideIndex, 0, false) && customSwiper.thumbs.update();
  });
  
  $('.header__icon--search').on( "click", function() {
    if($('.search-modal__form').is(":visible")){
      $('.search-modal__form .search__input').trigger('click');
		$('.search-modal__form .search__input').focus();
    }
  });
  const header_class = new StickyHeader();
  header_class.connectedCallback();
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      var item_href = this.getAttribute('href');
      if(item_href.length > 0){
        if(isSafari && window.innerWidth < 500 ){ //
  //         console.log(document.querySelector(this.getAttribute('href')));
  //         window.scrollTo(0, document.querySelector(this.getAttribute('href')).offsetTop - 40 )
          document.querySelector(item_href).scrollIntoView({
            behavior: 'smooth'
          });
        }
        else{
          $('html, body').animate({
            scrollTop: $(document.querySelector(item_href)).offset().top - 40
          }, 500);
        }
      }
      header_class.hide(true);
    });
  });

});


$(window).on('resize scroll', function() {
  isOnScreen($(`.${sections.video}`)) 
    ? $(`.${sections.video}`).removeClass("hide-background")
    : $(`.${sections.video}`).addClass("hide-background");
});

if($(".beforeafterdrag").length){
  $(".beforeafterdrag").cndkbeforeafter({
    mode: "drag",
    beforeTextPosition: "top-left",
     theme: "dark",
    seperatorWidth:"2px",
    seperatorOpacity: "1",
    showText: false
  });
}

$(window).keydown(function(event){
  if($(".cndkbeforeafter_circle").is(":focus")){
    handleKeys(event);
  }
});



function handleKeys(e) {

  var position, 
      currentElement = $(".beforeafterdrag"),
      draggable = currentElement.find(".cndkbeforeafter-seperator"),
      distance = 5; // Distance in pixels the draggable should be moved

  position = draggable[0].style.left;
  position = parseFloat(position.replace('%',''));

  // Reposition if one of the directional keys is pressed
  switch (e.keyCode) {
    case 37: position -= distance; break; // Left
    case 39: position += distance; break; // Right
    default: return true; // Exit and bubble
  }

  // Keep draggable within container
  if (position >= 0 && position<=100) {
    currentElement.find(".cndkbeforeafter-item-before-c").css("width",position+"%");
    currentElement.find(".cndkbeforeafter-item-after-c").css("width",(100-position)+"%");
    currentElement.find(".cndkbeforeafter-seperator").css("left",position+"%");
  }

  // Don't scroll page
  e.preventDefault();
}

// Taken from the original site for the Cookie Bar 
function GetCookie(name) {
  var arg=name+"=";
  var alen=arg.length;
  var clen=document.cookie.length;
  var i=0;
  while (i<clen) {
	var j=i+alen;
	if (document.cookie.substring(i,j)==arg)
	  return "here";
	i=document.cookie.indexOf(" ",i)+1;
	if (i==0) break;
  }
  return null;
}
function testFirstCookie(){
	var offset = new Date().getTimezoneOffset();
	if ((offset >= -180) && (offset <= 0)) { // European time zones
		var visit=GetCookie("cookieCompliancyAccepted");
		if (visit==null){
		   $("#myCookieConsent").delay(500).fadeIn(750);	// Show warning
	   } else {
			$("#myCookieConsent").hide();
	   }		
	}
}
$(document).ready(function(){
    $("#cookieButton").on( "click", function() {
		console.log('Akzeptieren');
		var expire=new Date();
		expire=new Date(expire.getTime()+7776000000);
		document.cookie="cookieCompliancyAccepted=here; expires="+expire+";path=/";
        $("#myCookieConsent").fadeOut(175);
    });
	testFirstCookie();
});

// cookie stuff
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function checkACookieExists(cname) {
	if (document.cookie.split(";").some((item) => item.trim().startsWith(cname + "="))) {
		return true;
	}

	return false;
}


$(document).ready(function(){
  // Please if someone knows a better way fix this - Pesho
//   if($('body').hasClass('template-product')){
//     setTimeout(function () {
//       var price_holder = $('.product .price_holder .price__regular').clone();
//       $('.rc_widget__option__selector[data-selector-onetime]').on( "click", function() {
//         $('.product .rc_popup').hide();
//       });

//       $('.rc_widget__option__selector[data-selector-subsave]').on( "click", function() {
//         $('.product .rc_popup').show();
//         
//       });r
//     }, 1000);
//   }

});


